import React from 'react'
import { DropDownList, ComboBox } from "@progress/kendo-react-dropdowns";

export default function UiTopDropDownList(props) {

  const { label, name, handleSelect, data, placeholder  } = props;

  return (
    <>
      <label className='sba-telerik-label'>{label}</label>
      <ComboBox
        data={data}
        textField="label"
        dataItemKey="value"
        name={name}
        onChange={(e)=>{handleSelect(e)}}
        placeholder={placeholder}

      />
     
    </>
  )
}


